import api from "./axios";


export async function login(email, password) {
  const { data } = await api.post("/api/auth/login", { email, password });
  return data;
}

export async function getCurrentAdmin() {
  const { data } = await api.get("/api/auth/me");
  return data;
}

export async function logout() {
  const { data } = await api.post("/api/auth/logout");
  return data;
}
